import jQuery from "jquery";
import 'bootstrap/js/dist/tooltip';

jQuery(document).ready(function ($) {
    $('.wpcf7.js span[title]').tooltip();
});